import React, { useState } from 'react';
import {
  IconButton,
  makeStyles,
  Theme,
  FormLabel,
  Grid,
} from '@material-ui/core';
import { Attachment } from '@material-ui/icons';

import Loader from '../Loader';
import Snackbar, { AlertComponentProps } from '../Snackbar';

import { getFileChip } from '../../utils/getChip';
import { useAxios } from '../../utils/hooks';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& > *': {
      padding: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  faceImage: {
    color: theme.palette.primary.main,
    fontSize: '1rem',
  },
  formLabel: {
    fontSize: '0.8rem',
  },
}));

interface FormProps {
  initialFiles?: File[];
  handleFileId: any;
}

export interface File {
  name: string;
  type: string;
  size: number;
}

const FileUploader: React.FC<FormProps> = ({ handleFileId, initialFiles }) => {
  const api = useAxios();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState<File[]>(initialFiles || []);
  const [alert, setAlert] = useState<
    AlertComponentProps & { isActive: boolean }
  >({
    isActive: false,
    type: 'info',
    message: 'none',
  });

  const handleCapture = async ({ target }: any) => {
    setLoading(true);
    const file = target.files[0];
    let fileResponse;

    try {
      const formData = new FormData();
      formData.append('file', file);

      fileResponse = await api.current?.post('/files', formData);

      if (fileResponse) {
        setAlert({
          isActive: true,
          type: 'success',
          message: 'Upload realizado com sucesso.',
        });
      }
    } catch (error) {
      setAlert({
        isActive: true,
        type: 'error',
        message: 'Erro ao salvar arquivo.',
      });
    } finally {
      setFiles([...files, file]);
      handleFileId(fileResponse?.data._id);
      setLoading(false);
    }
  };

  return (
    <>
      <Loader loading={loading} />

      <input
        className={classes.input}
        id="faceImage"
        type="file"
        onChange={handleCapture}
      />
      <FormLabel htmlFor="faceImage">
        <IconButton
          className={classes.faceImage}
          color="primary"
          aria-label="upload picture"
          component="span"
        >
          <Attachment fontSize="large" color="primary" />
          Anexar Arquivos
        </IconButton>
      </FormLabel>

      <Grid container spacing={2}>
        {files.map((file) => (
          <Grid item xs={12}>
            {getFileChip(file.type, file.name)}
          </Grid>
        ))}
      </Grid>

      {alert.isActive && <Snackbar {...alert} />}
    </>
  );
};

export default FileUploader;
